
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/getting-started/templates/marketing-page",
      function () {
        return require("private-next-pages/material-ui/getting-started/templates/marketing-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/getting-started/templates/marketing-page"])
      });
    }
  